﻿myApp.controller("joinusCtrl", ['$scope', '$http', '$timeout', function ($scope, $http, $timeout) {
    $scope.setPage("join");//navbar action
    $scope.setPageClass("yit-careers");
    $scope.jobs = [];
    $scope.formClass = "hide-form";
    $scope.apply = {};
    $scope.AllStrings = {
        form: {
            nameHolder: "",
            mailHolder: "",
            phoneHolder: "",
            fileHolder: ""
        }
    }
    $scope.WaitForStrings(function () {
        var xml = this.strings;
        var page = $(xml).find("joinus");

        $scope.AllStrings.title = $(page).find("title").first().find($scope.lang).text().trim();

        $scope.h1 = $(page).find("h1").find($scope.lang).html().trim();
        $scope.p = $(page).find("p").find($scope.lang).html().trim();
        $scope.setTitle($scope.AllStrings.title);//set title to the page

        var form = $(page).find("form");

        $scope.AllStrings.form.name = $(form).find("name").find($scope.lang).html().trim();
        $scope.AllStrings.form.mail = $(form).find("mail").find($scope.lang).html().trim();
        $scope.AllStrings.form.phone = $(form).find("phone").find($scope.lang).html().trim();
        $scope.AllStrings.form.file = $(form).find("file").find($scope.lang).html().trim();
        $scope.AllStrings.form.btn = $(form).find("btn").find($scope.lang).html().trim();
        $scope.AllStrings.form.text = $(form).find("text").find($scope.lang).html().trim();

        var jobs = $(page).find("jobs").children();
        jobs.each(function (index) {
            var title = $(this).find("title").find($scope.lang).html().trim();
            var desc = $(this).find("desc").find($scope.lang).html().trim();
            var req = $(this).find("req").find($scope.lang).html().trim();
            var detais;
            if ($scope.lang == "eng") {
                $scope.AllStrings.form.nameHolder = "Please enter a valid name";
                $scope.AllStrings.form.mailHolder = "Please enter a valid Email adress";
                $scope.AllStrings.form.phoneHolder = "Please enter a valid telephone number";
                $scope.AllStrings.form.privacyText = "i have read and understood";
                $scope.AllStrings.form.privacyLink = "the privacy policy";
                $scope.AllStrings.form.privacyErr = "* Approve privacy policy please";

                detais = "Show more"
            }
            else {
                detais = "הצג פרטים"

                $scope.AllStrings.form.nameHolder = "אנא הכנס שם תקין";
                $scope.AllStrings.form.mailHolder = "אנא הכנס כתובת  דואר אלקטרוני תקינה";
                $scope.AllStrings.form.phoneHolder = "אנא הכנס מספר טלפון תקין";
                $scope.AllStrings.form.privacyText = "קראתי, הבנתי והנני מסכים";
                $scope.AllStrings.form.privacyLink = "למדיניות הפרטיות באתר";
                $scope.AllStrings.form.privacyErr = "* נא לאשר את מדיניות הפרטיות";
            }

            $scope.jobs.push({
                title: title,
                desc: desc,
                req: req,
                closed: true,
                details: detais

            });
        });
    }.bind($scope));

    $scope.ApplyClick = function (index) {
        var open = "Show Details";
        var close = "Less Details";

        if ($scope.lang == "heb") {
            open = "הצג פרטים";
            close = "סגור פרטים";
        }


        if (this.job.closed) {
            this.job.details = close;
            this.job.closed = false;
        }
        else {
            this.job.details = open;
            this.job.closed = true;
        }
    }
    $scope.applay = function () {
        $scope.formClass = "show-form";
    }
    $scope.closeForm = function () {
        $scope.formClass = "hide-form";
    }
    $scope.ValidateForm = function (e) {
        var files = $("input[type=file]")[0].files.length;
        var msg = "Please add a Cv file";
        if (files <= 0)
        {
            if ($scope.lang == "heb")
            {
                msg = 'צרף קובץ קו"ח';
            }
        }
        else if ($("input[type=file]")[0].files[0].size > 4194304)
        {
            if ($scope.lang == "heb")
            {
                msg = "4 מגהבייט לכל היותר";
            }
            else
            {
                msg = "max 4 mb file allowed";
            }
        }
        else
        {
            msg = "";
            $scope.ContactUs();
        }
        $scope.AllStrings.form.fileHolder = msg
    }
    $scope.resetInputs = function () {

        $(".cvform input:not(.btn)").val("");
        $(".cvform textarea").val("");
        $scope.apply.name = "";
        $scope.apply.mail = "";
        $scope.apply.phone = "";
        $scope.apply.msg = "";
        $scope.formClass = "hide-form";
    }

    $scope.ContactUs = function () {
        //the user should read the privacy policy
        if ($("#privacyCheckbox").is(":checked") == false) {
            $("#privacyErr").css("visibility", "visible");
            return;
        }
        grecaptcha.ready(function () {
            grecaptcha.execute(AppSettings.reCaptchaSiteKey, { action: 'submit' }).then(function (token) {
                var dynamicForm = $("#dynamicform");
                var data = new FormData($(dynamicForm).find("form")[0]);

                var file = $(dynamicForm).find("input[name=file]")[0].files[0];

                data.set("Name", $scope.apply.name);
                data.set("Email", $scope.apply.mail);
                data.set("Phone", $scope.apply.phone);
                data.set("File", file);
                data.set("Message", $scope.apply.msg);
                data.set("recaptchaToken", token);

                var sUrl = "/JoinUs/Contact";
                $.ajax({
                    url: sUrl,
                    type: 'POST',
                    data: data,
                    contentType: false,
                    processData: false,
                    success: function (data) {
                        console.log(data);
                        $("#loader").fadeOut();
                        $("#async-message").fadeIn();
                        $scope.resetInputs();
                        $(dynamicForm).removeClass("hide");

                        $timeout(function () {
                            $("#async-message").fadeOut();
                            dataLayer.push({ 'event': 'virtualPageview', 'virtualPageURL': '/thank-you', 'virtualPageTitle': 'תודה על השארת פרטים' });

                        }, 5000);


                    },
                    error: function (x, h, r) {
                        console.log('error');
                        $("#loader").fadeOut();
                        $(dynamicForm).removeClass("hide");
                    }, complete: function () {
                        $scope.formClass = "hide-form";

                    }
                });
            });
        });
        

    }
    var win = $(window);

    var allMods = $("h2,.carrers-p");

    win.scroll(function (event) {
        allMods.each(function (i, el) {
            var el = $(el);
            if (el.visible(true)) {
                el.addClass("fadeup");
            }
        });
    });
}]);



//////////////////
// WEBPACK FOOTER
// ../scripts/yit/pages/joinus.js
// module id = 23
// module chunks = 0